import store from '@/store/index'

export default {
    /**
     * Handle Authorization response
     * @param responseData
     */
    buildAuthorization(responseData) {
        let currentDate = new Date()
        const auth = {
            userId: responseData.id,
            username: responseData.username,
            roles: responseData.roles,
            token: responseData.token,
            statusId: responseData.status_id,
            tokenExpires: new Date(currentDate.getTime() + (responseData.expires_in * 1000))
        }

        store.commit('setAuthorization', auth)
        return auth
    },

    getAuthorization() {
        if (!store.state || !store.state.authorization) {
            return null
        }

        return store.state.authorization;
    },

    /**
     * Get auth token if still valid
     * @return {null|*}
     */
    getAuthToken() {
        const auth = this.getAuthorization()
        if (!auth || !auth.tokenExpires) {
            return null
        }

        let tokenExpires = new Date(auth.tokenExpires)
        if (auth && auth.token && tokenExpires > new Date()) {
            return auth.token
        }

        return null
    },

    /**
     * Get user roles
     */
    getRoles() {
        const auth = this.getAuthorization()
        if (auth !== undefined && auth.roles !== undefined) {
            return auth.roles
        }
    },

    getOpenUrls() {
        return [
            'about',
            'enroll',
            'error',
            'login',
            'logout',
            'reset_password'
        ];
    },

    /**
     * Check if logged in
     * @return {boolean}
     */
    isAuthenticated() {
        return this.getAuthToken() !== null
    },

    /**
     * Check if has role
     * @param role
     */
    hasRole(role) {
        return this.isAuthenticated() && this.getRoles().indexOf(role) !== -1
    }
}
